import { Chart, Legend } from 'dyl-components';
import React, { useEffect } from 'react';
import { Grid, Header, Segment } from 'semantic-ui-react';
import { Pie } from 'dyl-components';
import { useDispatch, useSelector } from 'react-redux';
import userDashboardActions from 'actions/user_dashboard';

const PIESLICE = {
  "Connected": '#3B30CB',
  "Not Connected": '#303F9F',
  "Abandoned": '#616BEE',
  "Missed": '#CADDFF',
  "Transferred": '#DFE1FC',
  "Busy": '#214BD6',
  "Disconnected Number": '#616BEE',
  "Missed Attempt": '#B0B5F7',
  "Not Answered": '#F7F8FE',
  "Conference": '#C5CAE9',
  "Completed": '#7778FF',
};

const defaultLegend = Object.keys(PIESLICE)?.map((item) => ({
  name: item,
  value: 0,
  nameLabel: item,
  color: PIESLICE[item],
}));

const CallsChart = React.memo(({ statistic, data }) => {
  const legendData = data?.length ? defaultLegend?.map(ele => ({
    ...ele,
    color: PIESLICE[ele.name],
    value: data?.find(item => item.name === ele.name)?.value || 0,
  }))?.filter(item => item.value > 0) : defaultLegend;
  return (
    <div className="PieChart__ChartBlock">
      <div className="PieChart__ChartWrapper">
        <Chart width={150} height={150}>
          <Pie
            key={JSON.stringify(data)}
            data={data}
            innerRadius={30}
            outerRadius={50}
            animation={{ type: 'clockwise', duration: 1000 }}
            onMouseOver={() => { }}
            onMouseOut={() => { }}
            colorFunction={(type) => PIESLICE[type]}
            statistic={statistic}
          />
        </Chart>
      </div>

      <div>
        <Legend
          data={legendData}
          colorFunction={(segment) => PIESLICE[segment.name]}
        />
      </div>
    </div>
  );
});

export default function PieChart({ start_time, end_time }) {
  const { isReadingCallHistoryReport: loading } = useSelector((state) => state.user_dashboard);

  const rawOutbound = useSelector(state => state?.user_dashboard?.call_history_report?.outbound);
  const rawInbound = useSelector(state => state?.user_dashboard?.call_history_report?.inbound);
  const dispatch = useDispatch()
  const outboundReportData = rawOutbound ? Object.keys(rawOutbound).map(name => ({
    name,
    value: rawOutbound[name]
  })) : null;

  const inboundReportData = rawInbound ? Object.keys(rawInbound).map(name => ({
    name,
    value: rawInbound[name]
  })) : null

  const outboundStatistic = {
    header: outboundReportData?.map(item => item.value)?.reduce((a, b) => a + b, 0) || [0],
    subtitle: "Outbound Calls",
  };

  const inboundStatistic = {
    header: inboundReportData?.map(item => item.value)?.reduce((a, b) => a + b, 0) || [0],
    subtitle: "Inbound Calls",
  };

  useEffect(() => {
    dispatch(userDashboardActions.getCallHistoryReport({ start_time, end_time }))
  }, [dispatch, start_time, end_time])

  return (
    <Segment className="PieChart" loading={loading}>
      <Header as="h3" color="primary">
        Total Calls
      </Header>

      <Grid columns={2} stackable>
        <Grid.Row>
          <Grid.Column width={8} textAlign="center">
            {!loading && (
              <CallsChart
                statistic={outboundStatistic}
                data={outboundReportData}
              />
            )}
          </Grid.Column>
          <Grid.Column width={8} textAlign="center">
            {!loading && (
              <CallsChart
                statistic={inboundStatistic}
                data={inboundReportData}
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}
